import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';

import type { StepperVariant } from '../stepper';

export const container = css`
  display: grid;
  position: relative;
`;

export const inverse: Record<StepperVariant, ReturnType<typeof css>> = {
  vertical: css`
    grid-template-areas: 'content icon';
    grid-template-columns: 1fr max-content;
  `,
  horizontal: css`
    grid-template-areas: 'content' 'icon';
  `,
};

export const variant: Record<StepperVariant, (theme: Theme) => ReturnType<typeof css>> = {
  vertical: (theme: Theme) => css`
    grid-template-columns: max-content 1fr;
    grid-template-rows: max-content;
    grid-template-areas: 'icon content';
    column-gap: ${theme.spacing[12]};
    padding-bottom: ${theme.spacing[24]};

    ${breakpoint.up('sm')} {
      padding-bottom: ${theme.spacing[32]};
    }
  `,
  horizontal: (theme: Theme) => css`
    grid-template-columns: auto;
    grid-template-rows: max-content max-content;
    grid-template-areas: 'icon' 'content';
    row-gap: ${theme.spacing[16]};
  `,
};

export const last = css`
  padding-bottom: 0;

  ${breakpoint.up('sm')} {
    padding-bottom: 0;
  }
`;
